export const STATUS_SET = 'status.STATUS_SET';
export const ORDER_SET = 'status.ORDER_SET';
